import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { treeData } from '@/api/user';
import store from '@/store';
import { getUserId } from '@/utils/auth';
import baseRoutes from './baseRoutes';
import getPageTitle from '@/utils/get-page-title';

import { testRouterMode } from './modules/testRouterMode';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

Vue.use(Router);

const router = new Router({
  routes: baseRoutes
});

const whiteList = [
  '/login',
  '/pageOffice/report',
  '/pageOffice/reportFail',
  '/audit/pageOffice/report',
  '/audit/pageOffice/reportFail',
  '/reportManagement/pageOffice/report',
  '/reportManagement/pageOffice/reportFail'
]; // 不重定向白名单

router.beforeEach(async (to, from, next) => {
  document.title = getPageTitle(to.meta.title);

  if (whiteList.some(item => item == to.path)) {
    return next();
  }
  // 登录界面登录成功之后，会把用户信息保存在会话，存在时间为会话生命周期，页面关闭即失效。
  const userId = getUserId();

  if (userId) {
    if (to.path === '/login') {
      // 如果是访问登录界面，如果用户会话信息存在，代表已登录过，跳转到主页
      if (userId) {
        next({ path: '/' });
      } else {
        next();
      }
    } else {
      if (!userId) {
        next({ path: `/login` });
      } else {
        NProgress.start();
        if (store.state.app.menuRouteLoaded) {
          next();

          NProgress.done();
        } else {
          try {
            // 刷新用户信息
            await store.dispatch('user/getUserInfo');
            // 加载动态菜单和路由
            const accessRoutes = await addDynamicMenuAndRoutes(userId, to, from);
            // 保存加载状态
            store.commit('app/menuRouteLoaded', true);

            await firstEnterAddCachedView(to, accessRoutes, () => {
              next({ ...to, replace: true });
            });

            NProgress.done();
          } catch (error) {
            // 重置token 和 userId
            await store.dispatch('user/logout');

            next({ path: `/login` });
            NProgress.done();
          }
        }
      }
    }
  } else {
    next({ path: `/login` });
  }
});

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

export default router;

// 加载动态菜单和路由
function addDynamicMenuAndRoutes(userId, to, from) {
  return new Promise((resolve, reject) => {
    /******** 开发环境测试router Start ********/
    // const env = process.env.VUE_APP_BASE_ENV;
    // if (env == 'dev') {
    //   console.log('env 打印:', env);
    //   // 开发环境
    //   let subSysRoutes = [];
    //   subSysRoutes = testRouterMode;

    //   const dynamicRoutes = addDynamicRoutes(subSysRoutes);
    //   dynamicRoutes.map(item => {
    //     router.addRoute('Layout', item);
    //     router.addRoute({ path: '*', redirect: '/', hidden: true });
    //   });

    //   // 保存菜单树
    //   store.commit('menu/setNavTree', subSysRoutes);
    //   return resolve(dynamicRoutes);
    // }
    /******** 开发环境测试router End ********/

    treeData(userId)
      .then(rss => {
        const newData = [];
        const loops = data => {
          if (!data) return;
          data.forEach(item => {
            const { nodes, ...opt } = item;
            newData.push({
              id: opt.id,
              functype: opt.functype,
              code: opt.code
            });
            if (item.nodes && item.nodes.length) {
              loops(item.nodes);
            }
          });
        };
        loops(rss);

        // 保存权限按钮 code
        const codeArr = newData.filter(item => item.functype == 2).map(v => v.code);
        store.commit('user/SET_PERMS', codeArr);

        // 添加动态路由
        filterData(rss); //过滤菜单

        // 保存菜单树 sidebar使用
        store.commit('menu/setNavTree', rss);

        const dynamicRoutes = addDynamicRoutes(rss);
        // 处理静态组件绑定路由
        handleStaticComponent(router, dynamicRoutes);
        return resolve(dynamicRoutes);
      })
      .catch(err => {
        return reject(err);
      });
  });
}

function handleStaticComponent(router, dynamicRoutes) {
  dynamicRoutes.forEach(route => {
    router.addRoute('Layout', route); // 替换 'parentRouteName' 为实际的父路由名称
  });
  router.addRoute({ path: '*', redirect: '/', hidden: true });
}

/**
 * 过滤数据
 * @param data
 * @param value
 */
function filterData(data) {
  // 到叶子节点了，返回,递归出口
  if (data == undefined || data == null || data.length == 0) {
    return;
  } else {
    // 对每一层，遍历这个数组，调用filterData方法对每个元素下的数组进行同样的操作
    myFilter(data, 2);
    for (let index in data) {
      filterData(data[index].nodes);
    }
  }
}

function myFilter(data, value) {
  if (data == null || data == undefined || data.length == 0) {
    return;
  } else {
    for (let index = data.length - 1; index >= 0; index--) {
      // 删除状态2的元素,且不为过渡结点的元素
      if (data[index].functype == value) {
        data.splice(index, 1);
      }
    }
  }
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function addDynamicRoutes(menuList = [], routes = []) {
  let temp = [];

  for (let i = 0; i < menuList.length; i++) {
    if (menuList[i].nodes && menuList[i].nodes.length >= 1) {
      temp = temp.concat(menuList[i].nodes);
    } else if (menuList[i].tag && /\S/.test(menuList[i].tag) && !menuList[i].deleted) {
      menuList[i].tag = menuList[i].tag.replace(/^\//, '');
      // 创建路由配置
      let route = {
        path: menuList[i].tag,
        component: null,
        name: menuList[i].code,
        id: menuList[i].id,
        hidden: false,
        icon: menuList[i].icon,
        meta: {
          index: menuList[i].id,
          icon: menuList[i].icon,
          parentUrl: menuList[i].tag,
          title: menuList[i].text
        }
      };

      try {
        // 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
        // 如url="sys/user"，则组件路径应是"@/views/sys/user.vue",否则组件加载不到
        let array = menuList[i].tag.split('/');
        let url = '';
        for (let i = 0; i < array.length; i++) {
          url += array[i].substring(0, 1) + array[i].substring(1) + '/';
        }
        url = url.substring(0, url.length - 1);
        route['component'] = resolve => require([`@/views/${url}`], resolve);
      } catch (e) {
        console.error(e);
      }
      routes.push(route);
    }
  }

  if (temp.length >= 1) {
    addDynamicRoutes(temp, routes);
  } else {
  }
  return routes;
}

/**
 * 浏览器级别刷新时，遍历accessRoutes去追加state.cachedViews中的值，为了解决刷新后keep-alive失效的问题
 * @param {*} view 当前路由对象
 * @param {*} accessRoutes 路由数组
 * @param {*} callBack 回调
 */
async function firstEnterAddCachedView(view, accessRoutes, callBack) {
  if (view.name) {
    callBack();
    return;
  }
  async function recursive(accessRoutes) {
    const len = accessRoutes.length;
    for (let i = len - 1; i >= 0; i--) {
      const element = accessRoutes[i];
      if (!element.redirect && !element?.meta?.noCache) {
        await store.dispatch('tagsView/addCachedView', { name: element.name, meta: { noCache: false } });
      }
      const children = element.children || [];
      await recursive(children);
    }
  }
  await recursive(accessRoutes);
  await callBack();
}
